module.exports = __webpack_public_path__ + "static/socialshareopengraph-78e6d66573b224ba4e0ddb33f9c0caf3.jpg";